import throttle from 'lodash/throttle';
import { triggerMouseUp } from 'helpers/events';
import { ScrollHandler } from './index';

const THROTTLE_RATE = 10;

class IScrollScroll implements ScrollHandler {
  private iscroll: any | null;
  private _callback: null | (() => void) = null;

  public async init(element: HTMLElement) {
    await this.initInstance(element);
    this.initMouseOutHandling();
  }
  private async initInstance(element: HTMLElement) {
    // tslint:disable-next-line variable-name
    const IScroll = await this.load();
    this.iscroll = new IScroll(`#${ element.id }`, {
      bindToWrapper: false,
      mouseWheel: true,
      deceleration: 0.0011,
      resizePolling: 2000,
      disablePointer: true,
      disableMouse: false,
      disableTouch: false,
      bounceTime: 300,
      probeType: 3,
    });

    return this.iscroll;
  }
  private async load() {
    const module = await import(/* webpackChunkName: "iscroll" */ 'models/iscroll');
    return module.default;
  }
  private initMouseOutHandling() {
    // trigger mouseup event when mouse leaves window
    document.addEventListener('mouseout', (e) => {
      const fromElement = e.relatedTarget || (e as any).toElement;
      if (fromElement && (fromElement as any).nodeName !== 'HTML') {
        return;
      }

      triggerMouseUp(this.iscroll.wrapper);
    }, false);
  }

  public async reinitialize() {
    if (!this.iscroll) return Promise.reject();

    const element = this.iscroll.wrapper;
    this.iscroll.destroy();
    return this.initInstance(element);
  }

  public enable() {
    if (!this.iscroll) return;

    this.iscroll.initiated = false;
    this.iscroll.enable();
  }
  public disable() {
    if (!this.iscroll || !this.iscroll.disable) return;

    this.iscroll.disable();
  }

  public onScroll(callback: (data: { y: number }) => void) {
    this._callback = throttle(() => {
      const y = Math.round(this.iscroll.y) * -1;
      if (y + this.iscroll.wrapperHeight > this.iscroll.scrollerHeight) return;

      callback({
        y,
      });
    }, THROTTLE_RATE);
    this.iscroll.on('scroll', this._callback);
  }
  public offScroll() {
    if (!this.iscroll) return;
    this.iscroll.off('scroll', this._callback);
  }

  public scrollTo(offset: number, duration = 350) {
    if (!this.iscroll) return;
    this.iscroll.scrollTo(0, -offset, duration);
  }

  get type() {
    return 'iscroll';
  }
  get y() {
    if (!this.iscroll) return 0;
    return -this.iscroll.y;
  }

  public refresh(height?: number) {
    if (!this.iscroll) return;

    this.iscroll.refresh(true, height);
  }
  public onResize() {
    if (typeof this._callback !== 'function') return;

    this._callback();
  }
}

export default IScrollScroll;
